import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import environment from "environments/environment.js"

const mutation = graphql`
 mutation updateEmailTemplateMutation($input:saveHyblastEditorInput!){
  saveHyblastEditor(input:$input) {
    hyblastEditor {
      templateId
      rawMacrosHtml
      substitutedMacrosHtml
      fields{
        id
        label
        type
        value
        field
      }
    }
  }
}`;


function commit(input) {
  return new Promise((res, rej) => {
    commitMutation(environment, {
      mutation,
      variables: { input },
      onCompleted: res,
      onError: rej
    })
  });
};

export default commit;